import { required, shape, items, concatFailure } from '@totalsoft/pure-validations';

export const offerCancelledStatesValidator = shape({
  checkExpiredFolders: required,
  cancelledStateCode: required
});

export const offerCancelledConditionValidator = concatFailure(
  items(
    shape({
      documentTypeId: required,
      stateId: required,
      normalExpiryPeriod: required,
      extendedExpiryPeriod: required,
      referenceDate: required
    })
  )
);
